export async function readResponsePayload(response) {
    const text = await response.text().catch(() => '');
    if (!text) return null;

    try {
        return JSON.parse(text);
    } catch {
        return text;
    }
}

export function resolveErrorMessage(error, fallback = 'Ocorreu um erro inesperado.') {
    if (typeof error === 'string' && error.trim()) return error;

    if (error?.errors && typeof error.errors === 'object') {
        return Object.values(error.errors).flat().join('\n');
    }

    if (typeof error?.message === 'string' && error.message.trim()) {
        return error.message;
    }

    return fallback;
}
